import { useState, useEffect } from "react";
import db from "../firebase";
import logo from "../images/logo.svg";
import userSvg from "../images/user.svg";
import passwordSvg from "../images/password.svg";
import infoSvg from "../images/info.svg";
import facebookSvg from "../images/facebook.svg";
import googleSvg from "../images/google.svg";
import metamaskSvg from "../images/metamask.svg";
import emailSvg from "../images/email.svg";
import { useDispatch } from "react-redux";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from "firebase/auth";
import {
  doc,
  setDoc,
  collection,
  getDocs,
  query,
  where,
  updateDoc,
} from "firebase/firestore";
import {
  updateUserUid,
  updateUserName,
  updateUserUsername,
  updateUserEmail,
  updateUserProfileImage,
  updateUserFavorites,
  updateUserCollections,
  updateUserWallet,
  updateUserMetamaskAccount,
} from "../store/actions/index";
import {
  validateEmail,
  validateRequired,
  validatePassword,
  setCookie,
} from "./Common";

const SignInModal = () => {
  const auth = getAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    document
      .getElementById("loginmodal")
      .addEventListener("hidden.bs.modal", function (event) {
        setAuthData({
          username: "",
          password: "",
          email: "",
        });
      });
  }, []);

  const [authData, setAuthData] = useState({
    username: "",
    password: "",
    email: "",
  });

  const [authDataerror, setAuthDataerror] = useState({
    username: false,
    password: false,
    email: false,
  });

  const [signUpPage, setSignUpPage] = useState(false);
  const [metaMaskSignIn, setMetaMaskSignIn] = useState("");
  const [signInError, setSignInError] = useState(false);
  const [signUpError, setSignUpError] = useState(false);
  const [googleSignInError, setGoogleSignInError] = useState(false);
  const ethereum = window.ethereum;

  async function getFilteredCollectionData(path, key, value) {
    return await getDocs(query(collection(db, path), where(key, "==", value)));
  }

  async function getCollectionData(path) {
    return await getDocs(
      query(collection(db, `user_data/${path}/collections`))
    );
  }

  function removeModalFn() {
    let modal = document.getElementById("loginmodal");
    let body = document.getElementsByTagName("BODY")[0];
    body.style.overflow = "visible";
    body.classList.remove("modal-open");
    body.setAttribute("data-bs-overflow", "none");
    modal.classList.remove("show");
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("style", "display: none");
    document.body.removeChild(
      document.getElementsByClassName("modal-backdrop")[0]
    );
  }

  function metaMaskFn() {
    if (typeof ethereum === "undefined") {
      removeModalFn();
      alert("Please install Metamask.");
      return;
    }

    async function checkValid(ethereum) {
      const collectionnn = await getDocs(
        query(
          collection(db, "user_data"),
          where("metamask_account", "==", ethereum.selectedAddress)
        )
      );

      if (collectionnn.docs.length === 0) {
        setMetaMaskSignIn(ethereum.selectedAddress);
      } else {
        dispatch(updateUserEmail(collectionnn.docs[0].data().email));
        dispatch(updateUserName(collectionnn.docs[0].data().name));
        dispatch(updateUserProfileImage(""));
        dispatch(updateUserUid(collectionnn.docs[0].data().uid));
        dispatch(updateUserUsername(collectionnn.docs[0].data().username));
        dispatch(updateUserWallet(collectionnn.docs[0].data().wallet));
        dispatch(updateUserFavorites(collectionnn.docs[0].data().favorites));
        dispatch(
          updateUserMetamaskAccount(
            collectionnn.docs[0].data().metamask_account
          )
        );

        setCookie("active_user", collectionnn.docs[0].data().accessToken, 365);

        updateDoc(doc(db, "user_data", collectionnn.docs[0].data().uid), {
          token: collectionnn.docs[0].data().accessToken,
        });

        getCollectionData(collectionnn.docs[0].data().uid).then(
          (collection) => {
            const temp = [];
            collection.forEach((doc) => {
              temp.push(doc.data());
            });
            dispatch(updateUserCollections(temp));
          }
        );

        removeModalFn();
      }
    }

    if (ethereum.selectedAddress) {
      checkValid(ethereum);
    } else {
      ethereum.request({ method: "eth_requestAccounts" });
      ethereum.on("accountsChanged", function (accounts) {
        checkValid(ethereum);
      });
    }
  }

  function signInFn() {
    let defaultFalse = {
      username: false,
      password: false,
      email: false,
    };
    if (!validateEmail(authData.email)) {
      defaultFalse.email = true;
    }
    if (!validatePassword(authData.password)) {
      defaultFalse.password = true;
    }
    setAuthDataerror(defaultFalse);
    if (defaultFalse.email || defaultFalse.password) {
      return;
    }

    signInWithEmailAndPassword(auth, authData.email, authData.password)
      .then((userCredential) => {
        setCookie("active_user", userCredential.user.accessToken, 365);

        updateDoc(doc(db, "user_data", userCredential.user.uid), {
          token: userCredential.user.accessToken,
        });

        getFilteredCollectionData(
          "user_data",
          "uid",
          userCredential.user.uid
        ).then((user) => {
          dispatch(updateUserEmail(user.docs[0].data().email));
          dispatch(updateUserName(user.docs[0].data().name));
          dispatch(updateUserProfileImage(user.docs[0].data().profile_image));
          dispatch(updateUserUid(user.docs[0].data().uid));
          dispatch(updateUserUsername(user.docs[0].data().username));
          dispatch(updateUserWallet(user.docs[0].data().wallet));
          dispatch(updateUserFavorites(user.docs[0].data().favorites));
          dispatch(
            updateUserMetamaskAccount(user.docs[0].data().metamask_account)
          );

          getCollectionData(userCredential.user.uid).then((collection) => {
            const temp = [];
            collection.forEach((doc) => {
              temp.push(doc.data());
            });
            dispatch(updateUserCollections(temp));
          });
        });

        removeModalFn();
      })
      .catch(() => {
        setSignInError(true);
      });
  }

  function signUpFn() {
    let defaultFalse = {
      username: false,
      password: false,
      email: false,
      secret_phrase: false,
    };
    if (!validateRequired(authData.username)) {
      defaultFalse.username = true;
    }
    if (!validateEmail(authData.email)) {
      defaultFalse.email = true;
    }
    if (!validatePassword(authData.password)) {
      defaultFalse.password = true;
    }
    setAuthDataerror(defaultFalse);
    if (defaultFalse.username || defaultFalse.email || defaultFalse.password) {
      return;
    }

    createUserWithEmailAndPassword(auth, authData.email, authData.password)
      .then((userCredential) => {
        if (metaMaskSignIn !== "") {
          setDoc(doc(db, "user_data", userCredential.user.uid), {
            email: authData.email,
            name: authData.username,
            profile_image: "",
            uid: userCredential.user.uid,
            username: authData.username,
            wallet: 0,
            token: userCredential.user.accessToken,
            favorites: [],
            metamask_account: metaMaskSignIn,
          });
        } else {
          setDoc(doc(db, "user_data", userCredential.user.uid), {
            email: authData.email,
            name: authData.username,
            profile_image: "",
            uid: userCredential.user.uid,
            username: authData.username,
            wallet: 0,
            token: userCredential.user.accessToken,
            favorites: [],
            metamask_account: "",
          });
        }

        dispatch(updateUserEmail(authData.email));
        dispatch(updateUserName(authData.username));
        dispatch(updateUserProfileImage(""));
        dispatch(updateUserUid(userCredential.user.uid));
        dispatch(updateUserUsername(authData.username));
        dispatch(updateUserWallet(0));
        dispatch(updateUserFavorites([]));
        dispatch(updateUserMetamaskAccount(""));

        setCookie("active_user", userCredential.user.accessToken, 365);

        removeModalFn();
      })
      .catch((error) => {
        setSignUpError(true);
        if (error.code === "auth/email-already-in-use") {
          setSignUpError("already");
        }
      });
  }

  function googleSignInFn() {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((userCredential) => {
        const isNewUser = userCredential._tokenResponse.isNewUser;

        if (isNewUser === true) {
          setDoc(doc(db, "user_data", userCredential.user.uid), {
            email: userCredential.user.email,
            name: userCredential.user.displayName,
            profile_image: userCredential.user.photoURL,
            uid: userCredential.user.uid,
            username: userCredential.user.email.replace("@gmail.com", ""),
            wallet: 0,
            token: userCredential.user.accessToken,
            favorites: [],
            metamask_account: "",
          });
        } else {
          updateDoc(doc(db, "user_data", userCredential.user.uid), {
            profile_image: userCredential.user.photoURL,
            name: userCredential.user.displayName,
            token: userCredential.user.accessToken,
          });
        }

        dispatch(updateUserEmail(userCredential.user.email));
        dispatch(updateUserName(userCredential.user.displayName));
        dispatch(updateUserProfileImage(userCredential.user.photoURL));
        dispatch(updateUserUid(userCredential.user.uid));
        dispatch(
          updateUserUsername(
            userCredential.user.email.replace("@gmail.com", "")
          )
        );

        getFilteredCollectionData(
          "user_data",
          "uid",
          userCredential.user.uid
        ).then((user) => {
          dispatch(updateUserWallet(user.docs[0].data().wallet));
          dispatch(updateUserFavorites(user.docs[0].data().favorites));
          dispatch(
            updateUserMetamaskAccount(user.docs[0].data().metamask_account)
          );

          getCollectionData(userCredential.user.uid).then((collection) => {
            const temp = [];
            collection.forEach((doc) => {
              temp.push(doc.data());
            });
            dispatch(updateUserCollections(temp));
          });
        });

        setCookie("active_user", userCredential.user.accessToken, 365);

        removeModalFn();
      })
      .catch(() => {
        setGoogleSignInError(true);
      });
  }

  function facebookSignInFn() {
    const provider = new FacebookAuthProvider();
    signInWithPopup(auth, provider)
      .then((userCredential) => {
        const isNewUser = userCredential._tokenResponse.isNewUser;

        if (isNewUser === true) {
          setDoc(doc(db, "user_data", userCredential.user.uid), {
            email: userCredential.user.email,
            name: userCredential.user.displayName,
            profile_image: userCredential.user.photoURL,
            uid: userCredential.user.uid,
            username: userCredential.user.email.substring(
              0,
              userCredential.user.email.indexOf("@")
            ),
            wallet: 0,
            token: userCredential.user.accessToken,
            favorites: [],
            metamask_account: "",
          });
        } else {
          updateDoc(doc(db, "user_data", userCredential.user.uid), {
            profile_image: userCredential.user.photoURL,
            name: userCredential.user.displayName,
            token: userCredential.user.accessToken,
          });
        }

        dispatch(updateUserEmail(userCredential.user.email));
        dispatch(updateUserName(userCredential.user.displayName));
        dispatch(updateUserProfileImage(userCredential.user.photoURL));
        dispatch(updateUserUid(userCredential.user.uid));
        dispatch(
          updateUserUsername(
            userCredential.user.email.replace("@gmail.com", "")
          )
        );

        getFilteredCollectionData(
          "user_data",
          "uid",
          userCredential.user.uid
        ).then((user) => {
          dispatch(updateUserWallet(user.docs[0].data().wallet));
          dispatch(updateUserFavorites(user.docs[0].data().favorites));
          dispatch(
            updateUserMetamaskAccount(user.docs[0].data().metamask_account)
          );

          getCollectionData(userCredential.user.uid).then((collection) => {
            const temp = [];
            collection.forEach((doc) => {
              temp.push(doc.data());
            });
            dispatch(updateUserCollections(temp));
          });
        });

        setCookie("active_user", userCredential.user.accessToken, 365);

        removeModalFn();
      })
      .catch(() => {
        setGoogleSignInError(true);
      });
  }

  return (
    <div className="modal fade authModal" id="loginmodal" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <div className="container">
              <div className="row">
                <div className="col-12 mt-3 text-center">
                  <img src={logo} alt="Logo" className="modalLogo" />
                </div>
                <hr className="mt-4 mb-0" />
                <div className="col-12 mt-4">
                  <h3 className="text-center modalTitle">
                    {metaMaskSignIn !== ""
                      ? "Provide some basic details"
                      : signUpPage
                      ? "Sign Up"
                      : "Sign In"}
                  </h3>
                </div>
                <div className="col-12 px-4">
                  <form>
                    {signUpPage || metaMaskSignIn !== "" ? (
                      <>
                        <div className="col-12 mt-3 position-relative">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Username"
                            name="username"
                            value={authData.username}
                            onChange={(e) =>
                              setAuthData({
                                ...authData,
                                [e.target.name]: e.target.value,
                              })
                            }
                          />
                          <img
                            src={userSvg}
                            alt="User Icon"
                            className="beforeIcon"
                          />
                          <img
                            src={infoSvg}
                            alt="Info Icon"
                            className="afterIcon"
                            title="Usernsame is your unique name"
                          />
                        </div>
                        {authDataerror.username ? (
                          <div className="col-12">
                            <small className="text-danger">
                              Please enter a username.
                            </small>
                          </div>
                        ) : null}
                      </>
                    ) : null}
                    <div className="col-12 mt-3 position-relative">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        value={authData.email}
                        name="email"
                        onChange={(e) =>
                          setAuthData({
                            ...authData,
                            [e.target.name]: e.target.value,
                          })
                        }
                      />
                      <img
                        src={emailSvg}
                        alt="Email Icon"
                        className="beforeIcon"
                      />
                      <img
                        src={infoSvg}
                        alt="Info Icon"
                        className="afterIcon"
                        title="Your email address"
                      />
                    </div>
                    {authDataerror.email ? (
                      <div className="col-12">
                        <small className="text-danger">
                          Please enter a valid email address.
                        </small>
                      </div>
                    ) : null}

                    <div className="col-12 mt-3 position-relative">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        name="password"
                        value={authData.password}
                        onChange={(e) =>
                          setAuthData({
                            ...authData,
                            [e.target.name]: e.target.value,
                          })
                        }
                      />
                      <img
                        src={passwordSvg}
                        alt="Password Icon"
                        className="beforeIcon"
                      />
                      <img
                        src={infoSvg}
                        alt="Info Icon"
                        className="afterIcon"
                        title="Password must be atleast 8 digit long"
                      />
                    </div>

                    {authDataerror.password ? (
                      <div className="col-12">
                        <small className="text-danger">
                          Password must be minimum eight characters, containing
                          at least one digit, one uppercase, one lowercase and
                          one special character.
                        </small>
                      </div>
                    ) : null}
                    {signInError ? (
                      <div
                        className="alert alert-danger mt-3 alert-dismissible"
                        role="alert"
                      >
                        Incorrect email or password.
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="alert"
                          aria-label="Close"
                        ></button>
                      </div>
                    ) : null}
                    {signUpError || googleSignInError ? (
                      <div
                        className="alert alert-danger mt-3 alert-dismissible"
                        role="alert"
                      >
                        {signUpError === "already"
                          ? "Account already exist."
                          : "Something went wrong! Please try again later."}
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="alert"
                          aria-label="Close"
                        ></button>
                      </div>
                    ) : null}

                    <div className="d-grid mt-4">
                      <button
                        type="button"
                        className="btn modalSubmitBtn"
                        onClick={() =>
                          signUpPage || metaMaskSignIn !== ""
                            ? signUpFn()
                            : signInFn()
                        }
                      >
                        {signUpPage || metaMaskSignIn !== ""
                          ? "Sign Up"
                          : "Sign In"}
                      </button>
                    </div>
                  </form>
                </div>
                {!metaMaskSignIn ? (
                  <>
                    <hr className="mt-5 mb-4" />
                    <div className="col-12 mt-2 mb-1 d-flex justify-content-center">
                      <img
                        src={facebookSvg}
                        alt="Facebook Logo"
                        className="signUpIcons"
                        onClick={facebookSignInFn}
                      />
                      <img
                        src={googleSvg}
                        alt="Google Logo"
                        className="signUpIcons"
                        onClick={googleSignInFn}
                      />
                      <img
                        src={metamaskSvg}
                        alt="Metamask Logo"
                        className="signUpIcons"
                        onClick={metaMaskFn}
                      />
                    </div>
                    <div className="col-12 mt-4 mb-3">
                      <p
                        className="signUpText"
                        onClick={() =>
                          signUpPage
                            ? setSignUpPage(false)
                            : setSignUpPage(true)
                        }
                      >
                        {signUpPage
                          ? "Already have an account? Sign In Here"
                          : "Sign Up Here"}
                      </p>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInModal;
